module.exports = __webpack_public_path__ + "img/coop_credivill.f853809a.png";